import "../../../../App.css";
import Helper from "../../../../Common/Helper";
import { TablePanelInfo } from "../../../../Components/Headings/TableHeading/TablePanelInfo"
import { appContext } from "../../../../AppContext";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { rights } from "../../../../Common/RightsManager";
import IbssDataGrid from "../../../../Components/Data/DataGrid/IbssDataGrid";
import IbssActionButton, { IActionButton } from "../../../../Components/Buttons/ActionButton/IbssActionButton";
import IbssSvgIcon from "../../../../Components/Icons/SvgIcon/IbssSvgIcon";
import AddIcon from "../../../../Components/Icons/AddIcon";
import { Box } from "@mui/material";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlineTwoToneIcon from '@mui/icons-material/CheckCircleOutlineTwoTone';
import { GridRowSelectionModel } from "@mui/x-data-grid";
import { IbssPage } from "../../../../Components/Core/BasePage/IbssPage";

class ListIdentityProviders extends IbssPage<RouteComponentProps, IState> 
{
  private get labels() { return appContext().labels; }

  private userCanCreate: boolean;
  private userCanDelete: boolean;
  private userCanUpdate: boolean;

  private columns = [
    {
      field: Helper.nameOf<IRowData>("name"),
      headerName: this.labels.HubLabelName,
      flex: 1
    },
    {
      field: Helper.nameOf<IRowData>("securityProviderTypeName"),
      headerName: this.labels.HubLabelType,
      flex: 1
    },
    {
      field: Helper.nameOf<IRowData>("status"),
      headerName: this.labels.HubLabelActive,
      flex: 1,
      renderCell: (params: { row: IRowData }) => <>{params.row.status == 1 ? this.labels.HubLabelYes_S : this.labels.HubLabelNo_S}</>
    },
    {
      field: Helper.nameOf<IRowData>("isDefault"),
      headerName: this.labels.HubLabelDefault,
      flex: 1,
      renderCell: (params: { row: IRowData }) => <>{params.row.isDefault ? this.labels.HubLabelYes_S : this.labels.HubLabelNo_S}</>
    }
  ];

  constructor(props: RouteComponentProps)
  {
    super(props);

    this.userCanCreate = rights.DATAMODEL.IdentityProviders.Create.has();
    this.userCanDelete = rights.DATAMODEL.IdentityProviders.Delete.has();
    this.userCanUpdate = rights.DATAMODEL.IdentityProviders.Update.has();

    this.state =
    {
      isLoadingToGetIdentityProviders: false,
      identityProviders: [],
      selectedRows: []
    }
  }

  public async componentDidMount(): Promise<void>
  {
    await this.getIdentityProvidersData();
    this.pageTitle = this.labels.HubMenuSecurity
  }

  private async getIdentityProvidersData(): Promise<void>
  {
    this.setState({ isLoadingToGetIdentityProviders: true });

    try
    {
      const identityProvidersResponse = await appContext().webEntryApiClientV1.api.webentry.v1.security.identityProviders.get<IIdentityProvider[]>({});
      this.setState({ identityProviders: identityProvidersResponse, isLoadingToGetIdentityProviders: false });
    } catch (error)
    {
      this.setState({ isLoadingToGetIdentityProviders: false });
    }
  }

  private rowClick(id: string): void
  {
    const { history } = this.props;
    history.push("security-identity-providers/details/" + id);
  }

  private async deleteClicked(): Promise<void>
  {
    this.setState({ isLoadingToGetIdentityProviders: true });
    try
    {
      let index = 0;
      while (index < this.state.selectedRows.length)
      {
        await appContext().webEntryApiClientV1.api.webentry.v1.security.identityProviders.byIdentityproviderid.delete<IIdentityProvider[]>({
          identityproviderid: this.state.identityProviders.filter(x => x.id == this.state.selectedRows[index])[0].id
        });
        index = index + 1
      }
      await this.getIdentityProvidersData();
      this.setState({ isLoadingToGetIdentityProviders: false, selectedRows: [] });
    } catch (error)
    {
      this.setState({ isLoadingToGetIdentityProviders: false });
    }
  }

  public render(): JSX.Element
  {

    const actionButtons: IActionButton[] =
      [
        {
          label: this.labels.HubButtonDelete,
          icon: (
            <IbssSvgIcon>
              <DeleteOutlinedIcon />
            </IbssSvgIcon>
          ),
          color: "error",
          onClick: () => this.deleteClicked(),
          disabled: !this.userCanDelete || this.state.selectedRows.length == 0
        },
        {
          label: this.labels.HubButtonAdd,
          className: "addIcon",
          icon: (
            <IbssSvgIcon>
              <AddIcon />
            </IbssSvgIcon>
          ),
          color: "primary",
          disabled: this.userCanCreate === false,
          onClick: () => this.props.history.push('security-identity-providers/details/0'),
        },
      ];

    return (
      <div className="rightPanel-main-content">
        <div className="table-panel">
          <TablePanelInfo
            tableHeading={this.labels.HubLabelIdentityproviders}
            iconSrc="IdProvider"
          />
          <Box component="div" sx={{ display: 'flex', justifyContent: 'right', alignItems: 'center', my: 1, mr: 0 }}>
            <IbssActionButton buttons={actionButtons} />
          </Box>
          <div>
            <IbssDataGrid
              className="data-grid-clickable-row"
              loading={this.state.isLoadingToGetIdentityProviders}
              columns={this.columns}
              rows={this.state.identityProviders}
              disableRowSelectionOnClick
              onRowClick={(params) => this.rowClick(params.row.id)}
              checkboxSelection
              onRowSelectionModelChange={(rowSelectionModel: GridRowSelectionModel) => this.setState({ selectedRows: rowSelectionModel })}
              rowSelectionModel={this.state.selectedRows}
            />
          </div>
        </div>
      </div>
    );
  }
}

interface IState
{
  isLoadingToGetIdentityProviders: boolean,
  identityProviders: Array<IIdentityProvider>,
  selectedRows: GridRowSelectionModel
}

interface IRowData
{
  id: number;
  name: string;
  securityProviderTypeName: string;
  clickEvent: () => void;
  isDefault: string;
  status: number;
  Option: JSX.Element;
}

export interface IIdentityProvider
{
  id: number;
  name: string | null;
  securityProviderTypeId: number;
  securityProviderTypeName: string;
  clientId: string | null;
  tenantDomain: string | null;
  tenantId: string | null;
  isDefault: boolean;
  status: number;
}

export default withRouter(ListIdentityProviders);